import pictureMobile from './media-slider_mobile.jpg';
import pictureTablet from './media-slider_tablet.jpg';
import pictureDesktop from './media-slider_desktop.jpg';
import style from './media-slider.scss';
import $ from 'jquery';
import 'slick-carousel';

const script = () => {
  const cssClass: string = 'MediaSlider';
  const target: string = `.${cssClass}`;
  const targets: any = document.querySelectorAll(target);

  for (const elt of targets) {

    // test if element is init
    if (elt.dataset[`init${cssClass}`] || !$(elt).is(":visible")) {
      continue; // already init go to next iteration
    }
    // init element
    elt.dataset[`init${cssClass}`] = true;
    if ($('img', elt).length > 1) {
      $(elt).slick({
        dots: true,
        arrows: false,
      });
    }
  }
};

export {
  pictureMobile,
  pictureTablet,
  pictureDesktop,
  style,
  script,
};
